<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { Payroll, Employee } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import RemoveEmployeeFromPayrollForm from '@/components/salary/RemoveEmployeeFromPayrollForm.vue';
    import RemoveButton from '@/components/RemoveButton.vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    const props = defineProps<{
        payroll: Payroll;
        disabled: boolean;
        employees: Employee[];
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        employee_id: null,
        terminate: 0,
        termination_date: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="
            route('v2.salary.payrolls.remove-employee', {
                payroll: props.payroll.id,
                employeeId: form.employee_id,
            })
        "
        method="delete"
        :query-key="[QueryKey.PAYROLL, selectedCompanyId, props.payroll.id]"
        title="payrolls.remove_employee_from_payroll.header"
        submit-text="payrolls.remove_employee_from_payroll.remove_employee"
        submit-variant="destructive"
    >
        <template #trigger>
            <RemoveButton
                button-text="payrolls.other_buttons.remove_employee_from_payroll"
                :disabled="props.disabled"
            />
        </template>
        <RemoveEmployeeFromPayrollForm
            :form="form"
            :payroll="props.payroll"
            :employees="props.employees"
        />
    </DialogForm>
</template>
